module.exports = __webpack_public_path__ + "static/media/solar-panels-2.1ec644a8.jpg";